import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { APIHelperService } from './apiHelper.service';

@Injectable({ providedIn: 'root' })
export class YardiService {

  constructor(
    private http: HttpClient,
    private apiHelper: APIHelperService
  ) {
    // no-op
  }

  getAllProspects() {
    return this.http.get<any>(this.apiHelper.fillUrl('yardiProspects', {}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  getPropertyConfiguration() {
    return this.http.get<any>(this.apiHelper.fillUrl('yardiConfiguration', {}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  getILSConfiguration() {
    return this.http.get<any>(this.apiHelper.fillUrl('yardiILSConfiguration', {}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  checkYardiWorkers(id, queue) {
    return this.http.get<any>(this.apiHelper.fillUrl('yardiWorkers', {id: id}, {queue: queue}))
      .pipe(map(data => {
        return data;
      }));
  }

  getYardiSources() {
    return this.http.get<any>(this.apiHelper.fillUrl('yardiSources', {}, {}))
      .pipe(map(data => {
        return data;
      }));
  }

  getYardiSourcesAdmin(payload) {
    return this.http.post<any>(this.apiHelper.fillUrl('yardiSource', {id: payload._id}, {}), payload)
      .pipe(map(data => {
        return data;
      }));
  }
}
